<template>
  <div class="app-body">
    <router-view />
  </div>
</template>

<script>
export default {
  name: "AppBody"
}
</script>

<style lang="scss" scoped>
.app-body {
  padding: 15px 0;
}
</style>
